import { Package } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { paths } from 'src/routes/paths'
import { Column } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const FreeSamplesSection = () => {
  const navigate = useNavigate()
  const { t } = useLocalization()

  return (
    <Column
      id="free-samples"
      className="relative w-full scroll-mt-24 items-center overflow-hidden rounded-[32px] px-6 py-24 md:rounded-[44px] md:px-16 md:py-32"
    >
      <div
        className="absolute inset-0 [background-image:linear-gradient(to_right,rgba(0,0,0,0.025)_1px,transparent_1px),linear-gradient(to_bottom,rgba(0,0,0,0.025)_1px,transparent_1px)] [background-size:44px_44px] [mask-image:radial-gradient(circle_at_50%_42%,black,transparent_68%)] [-webkit-mask-image:radial-gradient(circle_at_50%_42%,black,transparent_68%)]"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute inset-0 flex items-center justify-center"
        aria-hidden
      >
        <div className="absolute size-[420px] rounded-full border border-stone-200/70 md:size-[560px]" />
        <div className="absolute size-[580px] rounded-full border border-stone-200/50 md:size-[760px]" />
      </div>

      <Column className="relative z-10 max-w-2xl items-center gap-6 text-center">
        <h2 className="text-balance text-4xl font-normal tracking-tight text-neutral-900 md:text-5xl">
          {t(
            'Get free samples before you order.',
            'Få gratisprover innan ni beställer.'
          )}
        </h2>
        <p className="max-w-xl text-lg leading-relaxed text-neutral-900 md:text-xl">
          {t(
            'Check quality, fit and print on a real product. Tell the Klayder team what you are planning, and we will send samples.',
            'Kolla kvalitet, passform och tryck på en riktig produkt. Berätta för Klayder-teamet vad ni planerar, så skickar vi prover.'
          )}
        </p>
        <Button
          size="lg"
          radius="full"
          variant="primaryOrange"
          onClick={() => navigate(paths.contact)}
        >
          <Package className="mr-2 size-5" strokeWidth={1.75} />
          {t('Request samples', 'Beställ prover')}
        </Button>
      </Column>
    </Column>
  )
}
